export const timelineTrack = {
  codeLine: '条线 SN-0712',
  title: '男团解约风波',
  summary: '从一条深夜小作文开始，到双方各自给出结果，整条线只用了九天。下面按时间排好，关键节点和最终结果都在。',
  entries: [
    {
      id: 't-1',
      date: '09-02',
      time: '21:10',
      tag: '事件起点',
      title: '匿名长文出现，指向团队内部长期存在排期争议',
      detail: '首发内容没有配图，只有一段时间线描述，当晚转发量不高，但被多个搬运号连续跟进。',
    },
    {
      id: 't-2',
      date: '09-03',
      time: '10:26',
      tag: '当事人回应',
      title: '涉事成员工作室发布简短声明，称"与事实有出入"',
      detail: '声明未逐条回应时间线，只强调已委托处理，评论区因此出现大量追问。',
    },
    {
      id: 't-3',
      date: '09-04',
      time: '23:47',
      tag: '出现反转',
      title: '一段彩排录音流出，与此前说法存在细节冲突',
      detail: '录音未标注完整日期，真实性存疑，但成为当天讨论量最高的话题。',
    },
    {
      id: 't-4',
      date: '09-05',
      time: '14:02',
      tag: '多方卷入',
      title: '巡演主办方被牵扯进来，回应称"按合同执行"',
      detail: '主办方只回应了排期部分，没有涉及团队内部争议。',
    },
    {
      id: 't-5',
      date: '09-06',
      time: '19:33',
      tag: '二次声明',
      title: '团队方补发第二份说明，承认部分排期确有调整',
      detail: '这份说明第一次给出了具体日期，也让整条线从"传闻"变成"可核对"。',
    },
    {
      id: 't-6',
      date: '09-07',
      time: '08:15',
      tag: '数据核对',
      title: '有粉丝整理公开行程，与声明中的日期出现重叠',
      detail: '重叠部分成为新焦点，但双方都没有再就此单独回应。',
    },
    {
      id: 't-7',
      date: '09-08',
      time: '21:00',
      tag: '协商阶段',
      title: '多方进入线下协商，相关话题陆续降温',
      detail: '当天起新增内容明显减少，讨论重心转向"最终会怎么处理"。',
    },
    {
      id: 't-8',
      date: '09-09',
      time: '17:40',
      tag: '冷处理',
      title: '双方账号同步删除相关动态，未再补充说明',
      detail: '这一步通常意味着进入冷处理，但避雷条线仍然保留。',
    },
  ],
  finalResult: {
    date: '09-10',
    time: '01:20',
    title: '最终结果：合约调整，巡演照常但更换部分场次',
    text: '截至本条线更新，双方已就合约做出了调整，已公布的巡演保留大部分场次，个别场次更换。整条线从起点到结果共 9 天，相关争议没有进一步升级。',
  },
};